<div class="photo-container" [style.height]="getViewHeight(selectedFiscalYear$ | async)">
    <div class="photo-list">

        <header class="row page-header">
            <div class="col-md-4">
                <h2 class="title pull-left">PHOTOS</h2>
            </div>
            <div class="col-sm-8 text-end">
                <div class="controls">
                    <button class="btn btn-link" (click)="addPhotosModal.showModal()">
                        <i class="fa fa-plus" aria-hidden="true"></i> Add Photos
                    </button>

                    <!-- <button class="btn btn-toggle btn-toggle-no-shadow" [ngClass]="{'selected': showFilter}" (click)="onToggleFilter()">
                        <i class="fa fa-filter" aria-hidden="true"></i> Filters
                    </button> -->

                    <!-- <sp-dropdown hideStyling="true" isButtonToggle="true" isMarginLeft="true">
                        <sp-dropdown-item  text="Component Assignment View" displayIcon="true" iconClass="fa-columns" (click)="showComponentAssignmentPane()"></sp-dropdown-item>
                    </sp-dropdown> -->
                </div>
            </div>
        </header>

        <!-- No Data Message -->
        <div *ngIf="(propertyPhotos$ | async).length == 0" class="no-components-msg">
            <div class="icon-container">
                <i class="fa-regular fa-folder-open fa-3x"></i>
            </div>
            <div>
                 <h3 class="margin-top-25">No photos have been added for your property!</h3>
                 <button class="btn btn-success" (click)="addPhotosModal.showModal()">
                    Add Photos
                </button>
             </div>
         </div>

        <div class="page-content">
            <sp-photo-gallery
                #photoGallery
                [photos]="propertyPhotos$ | async"
                [propertyId]="selectedPropertyId"
                [fiscalYear]="selectedFiscalYear"
                [reportSettings]="reportSettings$ | async"
                (viewPhoto)="openPhotoDetailPanel($event)"
                (bulkDownload)="onBulkDownload($event)"
                (bulkAssignComponent)="onBulkAssignComponent($event)"
                (bulkDelete)="onBulkDelete($event)"
                (bulkUpdatePhotoReportSettings)="onBulkUpdateReportSettings($event)"
                (sortChanged)="onSortChanged($event)"
            ></sp-photo-gallery>
        </div>

    </div>
    <div class="photo-detail-pane" [ngClass]="{'hide': !photoToView}">
        <sp-edit-photo-pane
            [photo]="photoToView"
            [propertyId]="selectedPropertyId"
            [fiscalYear]="selectedFiscalYear"
            (closePane)="closeDetailsPane()"
            (previewPhoto)="openPhotoViewer()"
            (updatePhoto)="onPhotoUpdated($event)"
            (deletePhoto)="onDeletePhoto()"
            (downloadPhoto)="onDownloadPhoto()"
        ></sp-edit-photo-pane>
    </div>
</div>

<sp-add-photos-modal
    #addPhotosModal
    [propertyId]="selectedPropertyId"
    (onClose)="onUploadPhotosComplete($event)"
></sp-add-photos-modal>

<sp-photo-viewer
    #photoViewer
    [photos]="sortPhotos(propertyPhotos$ | async)"
    [initialPhotoId]="photoToView?.propertyPhotoId"
    (editPhoto)="onViewerEditPhoto($event)"
    (downloadPhoto)="onViewerDownloadPhoto($event)"
></sp-photo-viewer>

<sp-modal title="ERROR" cancelButtonText="Ok" isAlert="true" isWarning="true" #errorModal>
    {{errorMsg}}
</sp-modal>

